import { render, staticRenderFns } from "./ECensoCardEscola.vue?vue&type=template&id=0be2d453&scoped=true"
import script from "./ECensoCardEscola.vue?vue&type=script&lang=js"
export * from "./ECensoCardEscola.vue?vue&type=script&lang=js"
import style0 from "./ECensoCardEscola.vue?vue&type=style&index=0&id=0be2d453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be2d453",
  null
  
)

export default component.exports